import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { SensorTypeService } from 'src/app/services/sensor-type/sensor-type.service';
import { SensorService } from 'src/app/services/sensor/sensor.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { decryptData } from 'src/app/shared/helpers/decrypt';
import { SensorValueModalComponent } from './sensor-value-modal/sensor-value-modal.component';
import { MessageModalComponent } from '../message/message-modal.component';

@Component({
  selector: 'app-sensor-modal',
  templateUrl: './sensor-modal.component.html',
  styleUrls: ['./sensor-modal.component.css']
})
export class SensorModalComponent implements OnInit {

  sensorForm: FormGroup;
  gatewaySelect: number;
  headquarterSelect: number;
  edit = false;
  editHeadquarter = false;
  gateways = [];
  headquarters = [];
  sensorTypes = [];
  sensorSubTypes = [];
  initSensorSubTypes = [];
  disabledHeadquarter = false;
  sensorTypeSelect: number;
  sensorSubTypeSelect: number;
  userPermissionMaster: number;
  existPanelIOT = false;
  sensorValues = [];

  constructor(
    public dialogRef: MatDialogRef<SensorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private sensorService: SensorService,
    private sensorTypeService: SensorTypeService,
    private headquarterService: HeadquarterService,
    public dialog: MatDialog,
    public dialog2: MatDialog,
    private spinner: NgxSpinnerService,
  ) {
    this.userPermissionMaster = +decryptData(localStorage.getItem(AppConstants.Session.USER_MASTER_PERMISSION));
   }

  ngOnInit() {
    this.createForm();
    this.gateways = this.data.gateways;
    console.log("gateways",this.gateways);
    this.headquarters = this.data.headquarters;
    this.setHeadquarter();
    if(this.data.action == AppConstants.OperationType.ADD){
      this.editHeadquarter = false;
      this.edit = false;
      if(this.data.idGateway > 0){
        var gateways = this.data.gateways;
        this.headquarterSelect = (gateways.filter(x => x.id == this.data.idGateway)[0]).idHeadquarter;
      }

      if(this.data.idHeadquarter){
        this.headquarterSelect = this.data.idHeadquarter;
      }
      if(this.data.idGateway){
        this.gatewaySelect = this.data.idGateway;
      }
      console.log("gateways",this.gateways);
      console.log("gatewaySelect",this.gatewaySelect);
    }
    this.getSensorTypes();
    if(this.data.action == AppConstants.OperationType.UPDATE){
      this.edit = true;
      this.editHeadquarter = true;
      this.gateways = this.data.gateways.filter(x => x.idHeadquarter == this.data.obj.idHeadquarter);
      this.gatewaySelect = this.data.obj.idGateway;
      this.headquarterSelect = this.data.obj.idHeadquarter;
      this.sensorForm.controls['idGateway'].setValue(this.data.obj.idGateway);
      this.sensorForm.controls['name'].setValue(this.data.obj.name);
      this.sensorForm.controls['description'].setValue(this.data.obj.description);
      this.sensorForm.controls['nomenclature'].setValue(this.data.obj.nomenclature);
      this.sensorForm.controls['idSensorType'].setValue(this.data.obj.idSensorType);
      this.existPanelIOT = this.data.obj.existPanelIOT ? true : false;
      this.getSensorValues();
    }
  }

  setHeadquarter(){
    if(this.data.idHeadquarter > 0){
      var headquarters = JSON.parse(localStorage.getItem(AppConstants.Session.HEADQUARTERS));
      var _this = this;
      var items = headquarters.filter(x => x.idEnterprise == _this.data.idEnterprise);
      if(items.length > 0){
        _this.headquarters = items;
        if(_this.data.idHeadquarter != 0){
          _this.headquarterSelect = items[0].id;
          _this.disabledHeadquarter = true;
        }
      }
      /*this.gateways = this.gateways.filter(x => x.idHeadquarter == this.headquarterSelect);
      if(this.gateways.length>0){
        this.gatewaySelect = this.gateways[0].id;
      }*/
    }else{
      this.getHeadquarters();
    }
  }

  getHeadquarters() {
    this.spinner.show();
    this.headquarterService.getListAll().subscribe((response) => {
      if(response.error == null){
        this.headquarters = response.data.filter(f => f.idEnterprise == this.data.idEnterprise);
        if(this.data.obj != null){
          this.headquarterSelect = this.data.obj.idHeadquarter;
        }else{
          this.headquarterSelect = this.headquarters[0].id;
        }

        this.gateways = this.gateways.filter(x => x.idHeadquarter == this.headquarterSelect);
        if(this.gateways.length>0){
          this.gatewaySelect = this.gateways[0].id;
        }
      }else{
        this.headquarters = [];
      }
      this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.headquarters = [];
        this.spinner.hide();
      });
}

getSensorValues(){
  this.sensorService.getListSensorValues(this.data.obj.id).subscribe((response) => {
    if(response.error == null){
      this.sensorValues = response.data;
    }
  },
    (error: HttpErrorResponse) => {
      this.spinner.hide();
  });
}

getSensorTypes(){
  this.spinner.show();
  this.sensorTypeService.getListAll().subscribe((response) => {
    if(response.error == null){
      this.sensorTypes = response.data;
      if(this.data.action == AppConstants.OperationType.UPDATE){
        this.sensorForm.controls['idSensorType'].setValue(this.data.obj.idSensorType);
        this.sensorTypeSelect = this.data.obj.idSensorType;
      }else{
        this.sensorForm.controls['idSensorType'].setValue(this.sensorTypes[0].id);
        this.sensorTypeSelect = this.sensorTypes[0].id;
      }
      this.getSensorSubTypes();
    }
    this.spinner.hide();
  },
    (error: HttpErrorResponse) => {
      this.spinner.hide();
  });
}

getSensorSubTypes(){
  this.spinner.show();
  this.sensorTypeService.getListSubTypes().subscribe((response) => {
    if(response.error == null){
      this.initSensorSubTypes = response.data;
      this.sensorSubTypes = this.initSensorSubTypes.filter(x => x.idSensorType == this.sensorTypeSelect);
      if(this.data.action == AppConstants.OperationType.UPDATE){
        this.sensorForm.controls['idSensorSubType'].setValue(this.data.obj.idSensorSubType);
        this.sensorSubTypeSelect = this.data.obj.idSensorSubType;
      }else{
        if(this.sensorSubTypes.length>0){
          this.sensorForm.controls['idSensorSubType'].setValue(this.sensorSubTypes[0].id);
          this.sensorSubTypeSelect = this.sensorSubTypes[0].id;
        }
      }
    }
    this.spinner.hide();
  },
    (error: HttpErrorResponse) => {
      this.spinner.hide();
  });
}


  createForm(){
    this.sensorForm = this.formBuilder.group({
      name: ['', [Validators.required,  Validators.maxLength(50)]],
      description: ['', []],
      nomenclature: ['', [Validators.required,  Validators.maxLength(30),  Validators.minLength(1)]],
      idGateway: ['', [Validators.required]],
      idHeadquarter: ['', [Validators.required]],
      idSensorType: ['', [Validators.required]],
      idSensorSubType: ['', []]
    })
  }

  get f() { return this.sensorForm.controls; }

  save(){
    if(this.sensorForm.valid){
      const payload = {
        name:this.sensorForm.value["name"],
        nomenclature:this.sensorForm.value["nomenclature"],
        description:this.sensorForm.value["description"],
        id: this.data.action == AppConstants.OperationType.UPDATE ? this.data.obj.id : 0,
        idHeadquarter: this.headquarterSelect,
        idSensorType: this.sensorTypeSelect,
        idSensorSubType: this.sensorSubTypeSelect ?  this.sensorSubTypeSelect: 0,
        idEnterprise: this.data.idEnterprise,
        idGateway: this.gatewaySelect,
        idUser: localStorage.getItem(AppConstants.Session.USERID)
      }
      this.spinner.show();
      if(this.data.action == AppConstants.OperationType.ADD){
        this.sensorService.create(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.CREATE_SENSOR, AppConstants.MessageModal.CREATE, MessageSeverity.success);
            this.spinner.hide();
            this.data.result = true;
            this.dialogRef.close(this.data);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
              this.spinner.hide();
          }
        });
      }else{
        console.log("payload",payload);
        this.sensorService.update(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.UPDATE_SENSOR, AppConstants.MessageModal.UPDATE, MessageSeverity.success);
            this.spinner.hide();
            this.data.result = true;
            this.dialogRef.close(this.data);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
          }
        });
        this.spinner.hide();
      }
    }else{
      this.sensorForm.markAllAsTouched();
    }
  }

  close() {
    this.dialog.closeAll();
  }

  editValue(item){
      let dialogRef = this.dialog2.open(SensorValueModalComponent, {
        data: {
          title: AppConstants.TitleModal.UPDATE_SENSOR_VALUE,
          action: AppConstants.OperationType.UPDATE,
          id: item.id,
          idSensor: this.data.obj.id,
          idHeadquarter: this.headquarterSelect,
          idGateway: this.gatewaySelect,
          enabledWrite: this.data.enabledWrite,
          enabledRead: this.data.enabledRead,
          color: this.data.color,
          colorFont: this.data.colorFont,
          userPermissionMaster: this.userPermissionMaster,
          obj:item},
        width: '700px',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(_ => {
        if (_.result == true) {
          this.getSensorValues();
        }
      });
  }

  addValue(){
    let dialogRef = this.dialog2.open(SensorValueModalComponent, {
      data: {
        title: AppConstants.TitleModal.CREATE_SENSOR_VALUE,
        action: AppConstants.OperationType.ADD,
        id: 0,
        idSensor: this.data.obj.id,
        idHeadquarter: this.headquarterSelect,
        idGateway: this.gatewaySelect,
        enabledWrite: this.data.enabledWrite,
        enabledRead: this.data.enabledRead,
        color: this.data.color,
        colorFont: this.data.colorFont,
        userPermissionMaster: this.userPermissionMaster,
        obj:null},
      width: '700px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        this.getSensorValues();
      }
    });
  }

  deleteValue(obj) {
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.DELETE_CONFIRMATION_TITLE,
        message: `${AppConstants.MessageModal.DELETE_DEFAULT}`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteSecurity(obj.id);
      }
    });

  }

    deleteSecurity(id: number) {
      this.spinner.show();
      this.sensorService.deleteValue(id).subscribe((response => {
        this.spinner.hide();
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_SENSOR, AppConstants.MessageModal.DELETE, MessageSeverity.success);
        this.getSensorValues();
      }),
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_SENSOR, error.error.messages, MessageSeverity.error);
        this.spinner.hide();
      });
    }


  changeGateway(data) {
    this.gatewaySelect = data.value;
  }

  changeHeadquarter(data) {
    this.headquarterSelect = data.value;
    this.gateways = this.data.gateways.filter(x => x.idHeadquarter == data.value);
    if(this.gateways.length>0){
      this.gatewaySelect = this.gateways[0].id;
    }else{
      this.gatewaySelect = null;
    }
  }

  changeSensorType(data) {
    this.sensorTypeSelect = data.value;
    this.sensorSubTypes = this.initSensorSubTypes.filter(x => x.idSensorType == this.sensorTypeSelect);
  }

  changeSensorSubType(data) {
    this.sensorSubTypeSelect = data.value;
  }
}

